import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import React from "react";


import { useDispatch, useSelector } from "react-redux";
import booking_svg from "../assets/bookingLink.svg";
import { useToast } from "../provider/ToastProvider";
import { loadingState, setActionLoading } from "../redux/reducers/loadingReducer";
import { getUrlForBookings } from "../utils/confighelpers";
import { TwButton } from "./tailwind";

export default function SuccessParticipantModal({
  open,
  handleClose,
  fullName,
  phoneNumber,
  bookingId,
  handleUpdate,
}) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);

  const onClickSendTikkie = async (number) => {
    addToast("Generating Link");
    dispatch(setActionLoading(true));
    const request = await axios.post(
      `${getUrlForBookings()}payments/generateTikkiePmtLink`,
      { bookingId, forceSendLink: true, bookingFor: "Tikkie", },
    );
    dispatch(setActionLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        const numberCopy = number.replace(/[^\w\s]/gi, "").replace(/ /g, "");
        let url = `https://web.whatsapp.com/send?phone=${numberCopy}`;
        const message = `Hi! Here's the tikkie link for the payment of my session.\n${request.data.generatedUrl}`;
        url += `&text=${encodeURI(message)}&app_absent=0`;
        window.open(url);
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-brown-coffee px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md bg-brown-coffee text-white hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="sm:flex sm:items-center">
              <div className={"flex flex-col gap-10 p-8 pt-4 w-full"}>
                <div className={"flex flex-row items-center justify-between border-b border-light-brown-coffee pb-3"}>
                  <h3 className={"font-bold text-2xl text-white"}>Add New</h3>
                </div>
                <div className={"flex flex-col gap-2"}>
                  <img src={booking_svg} alt={""} />
                  <p className={"font-medium text-base text-center text-white"}>
                    {fullName} added to the Session
                  </p>
                </div>
                <TwButton
                  variant={"orange"}
                  onClick={() => onClickSendTikkie(phoneNumber)}
                  disabled={loadingReduxState.actionLoading}
                  actionLoading={(loadingReduxState.actionLoading)}
                >
                  Send Tikkie Request
                </TwButton>
                <p className={"font-medium text-sm text-white text-center cursor-pointer"}
                  onClick={() => {
                    handleClose();
                    handleUpdate();
                  }}
                >
                  Skip for now
                </p>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
